<div *ngIf="!selectedEpisode">
  <div class="page-header">
    <h1>TV Production Tracker</h1>
    <p>Production Planning & Workflow Management</p>
  </div>



  <div class="filter-toolbar">


    <button class="filter-btn" style="width: 220px; justify-content: space-between;">
      <div style="display:flex; align-items:center; gap:8px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <ng-container *ngIf="currentView === 'Month'">{{ currentDate | date:'MMMM yyyy' }}</ng-container>
        <ng-container *ngIf="currentView === 'Week'">{{ getWeekRangeText() }}</ng-container>
        <ng-container *ngIf="currentView === 'Day'">{{ currentDate | date:'EEEE, MMMM d, yyyy' }}</ng-container>
      </div>
    </button>

    <!-- <select class="filter-btn" [(ngModel)]="priority" (ngModelChange)="applyFilter('priority')">
      <option value="">Priority</option>
      <option *ngFor="let p of priorities" [value]="p">{{p}}</option>
    </select> -->

    <select class="filter-btn" [(ngModel)]="episodeType" (ngModelChange)="applyFilter('episodeType')">
      <option value="">Episode Type</option>
      <option *ngFor="let t of episodeTypes" [value]="t">{{t}}</option>
    </select>

    <select class="filter-btn" [(ngModel)]="episodeStatus" (ngModelChange)="applyFilter('episodeStatus')">
      <option value="">Workflow Status</option>
      <option *ngFor="let s of episodeStatuses" [value]="s.key">{{s.label}}</option>
    </select>

    <!-- <button class="filter-btn">
      Assigned User
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button> -->

    <button class="btn-reset" (click)="resetFilters()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
        <path d="M3 3v5h5"></path>
      </svg>
      Reset Filters
    </button>

    <button class="btn-primary" data-toggle="modal" data-target="#exampleModal">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
      Add Episode
    </button>
  </div>

  <div class="main-layout">
    <div class="calendar-section">
      <div class="calendar-toolbar">
        <div class="calendar-toolbar-left">
          <div class="btn-group">
            <button [class.active]="currentView === 'Month'" (click)="changeView('Month')">Month</button>
            <button [class.active]="currentView === 'Week'" (click)="changeView('Week')">Week</button>
            <button [class.active]="currentView === 'Day'" (click)="changeView('Day')">Day</button>
          </div>

          <div class="calendar-nav">
            <button (click)="prev()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <button (click)="goToToday()">{{ currentView }}</button>
            <button (click)="next()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>

        <div class="calendar-title">
          <ng-container *ngIf="currentView === 'Month'">{{ currentDate | date:'MMMM yyyy' }}</ng-container>
          <ng-container *ngIf="currentView === 'Week'">{{ getWeekRangeText() }}</ng-container>
          <ng-container *ngIf="currentView === 'Day'">{{ currentDate | date:'EEEE, MMMM d, yyyy' }}</ng-container>
        </div>
      </div>

      <div class="calendar-grid" *ngIf="currentView === 'Month'">
        <div class="calendar-day-header">Sun</div>
        <div class="calendar-day-header">Mon</div>
        <div class="calendar-day-header">Tue</div>
        <div class="calendar-day-header">Wed</div>
        <div class="calendar-day-header">Thu</div>
        <div class="calendar-day-header">Fri</div>
        <div class="calendar-day-header">Sat</div>

        <div class="calendar-cell" *ngFor="let day of calendarDays" [ngClass]="{'inactive': !day.isCurrentMonth}">
          <div class="date-number">{{ day.dateNumber }}</div>

          <div class="event-item" *ngFor="let event of day.events" [ngClass]="getStageClass(event.episodeStatus)"
            (click)="openEpisodeDetails(event.tvProductionTrackerId)">
            <div class="event-title">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
                <line x1="7" y1="2" x2="7" y2="22"></line>
                <line x1="17" y1="2" x2="17" y2="22"></line>
                <line x1="2" y1="12" x2="22" y2="12"></line>
              </svg>
              {{ event.episodeName || 'Unnamed' }}
            </div>
            <div class="event-type">{{ event.episodeType || 'Unknown Type' }}</div>
            <div class="event-status">
              <!-- <span class="status-dot" [ngClass]="{
              'dot-high': event.priority === 'HIGH',
              'dot-medium': event.priority === 'MEDIUM',
              'dot-low': event.priority === 'LOW'
            }"></span> -->
              {{ statusMap[event.currentStage] || event.currentStage }}
            </div>
          </div>
        </div>
      </div>

      <!-- WEEK VIEW -->
      <div class="week-grid" *ngIf="currentView === 'Week'">
        <div class="week-header">
          <div class="time-col-header">All Day</div>
          <div class="day-col-header" *ngFor="let day of weekDays">
            <span class="day-name">{{ day.dayName }}</span>
            <span class="day-number">{{ day.dateNumber }}</span>
          </div>
        </div>
        <div class="week-body">
          <div class="time-col">
            <div class="time-slot">6 AM</div>
            <div class="time-slot">8 AM</div>
            <div class="time-slot">10 AM</div>
            <div class="time-slot">12 PM</div>
            <div class="time-slot">2 PM</div>
            <div class="time-slot">4 PM</div>
            <div class="time-slot">6 PM</div>
            <div class="time-slot">8 PM</div>
          </div>
          <div class="days-container">
            <div class="grid-lines">
              <div class="grid-line" *ngFor="let i of [1,2,3,4,5,6,7,8]"></div>
            </div>

            <div class="day-col" *ngFor="let day of weekDays">
              <div class="week-event-card" *ngFor="let event of day.events"
                [ngClass]="getStageClass(event.episodeStatus)" [ngStyle]="getEventStyle(event)"
                (click)="openEpisodeDetails(event.tvProductionTrackerId)">

                <div class="week-event-content">
                  <div class="week-event-header">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
                      <line x1="7" y1="2" x2="7" y2="22"></line>
                      <line x1="17" y1="2" x2="17" y2="22"></line>
                      <line x1="2" y1="12" x2="22" y2="12"></line>
                    </svg>
                    {{ event.episodeName || 'Unnamed' }}
                  </div>
                  <div class="week-event-type">{{ event.episodeType || 'Type' }} &bull; {{
                    statusMap[event.episodeStatus] || event.episodeStatus }}</div>
                </div>

                <!-- <div class="week-progress-container">
                  <div class="week-progress-bar">
                    <div class="week-progress-fill" [style.width]="getProgress(event.episodeStatus) + '%'"></div>
                  </div>
                  <span class="week-progress-text">{{ getProgress(event.episodeStatus) }}%</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DAY VIEW -->
      <div class="day-list-view" *ngIf="currentView === 'Day'">
        <div class="day-list-header">
          <div class="time-col-header">All Day</div>
        </div>
        <div class="day-list-body">

          <div class="day-list-row" *ngFor="let event of dayEvents" [ngClass]="getStageClass(event.episodeStatus)"
            (click)="openEpisodeDetails(event.tvProductionTrackerId)">
            <div class="day-time-col">
              <span *ngIf="event.shootTime">{{ event.shootTime }}</span>
              <span *ngIf="!event.shootTime">All Day</span>
            </div>

            <div class="day-event-card">
              <div class="day-event-left">
                <div class="day-event-icon-title">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
                    <line x1="7" y1="2" x2="7" y2="22"></line>
                    <line x1="17" y1="2" x2="17" y2="22"></line>
                    <line x1="2" y1="12" x2="22" y2="12"></line>
                  </svg>
                  <span class="day-event-title">{{ event.episodeName || 'Unnamed' }}</span>
                </div>
                <div class="day-event-meta">{{ event.episodeType || 'Type' }} &bull; {{ statusMap[event.episodeStatus]
                  || event.episodeStatus }}</div>
              </div>

              <div class="day-event-assignee">
                <div class="assignee-avatar">{{ (event.anchorUser || 'A').charAt(0).toUpperCase() }}</div>
                <span class="assignee-name">{{ event.anchorUser || 'Unassigned' }}</span>
              </div>

              <!-- <div class="day-event-progress">
                <div class="day-progress-bar">
                  <div class="day-progress-fill" [style.width]="getProgress(event.episodeStatus) + '%'"></div>
                </div>
                <span class="day-progress-text">{{ getProgress(event.episodeStatus) }}%</span>
              </div> -->
            </div>
          </div>

          <div class="no-events" *ngIf="dayEvents.length === 0">
            No events scheduled for this day.
          </div>
        </div>
      </div>

      <div class="calendar-footer">
        <!-- <div class="priority-legend">
          <span style="font-weight: 500;">Priority:</span>
          <div class="priority-item"><span class="status-dot dot-high"></span> HIGH</div>
          <div class="priority-item"><span class="status-dot dot-medium"></span> MEDIUM</div>
          <div class="priority-item"><span class="status-dot dot-low"></span> LOW</div>
        </div> -->
        <!-- <div class="drag-drop-hint">
        Drag & drop to reschedule episodes
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </div> -->
      </div>
    </div>

    <div class="right-panel">
      <div class="panel-card">
        <div class="panel-title">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          Today's Schedule
        </div>
        <div class="schedule-date">{{ todayDate | date:'EEEE, MMMM d, yyyy' }}</div>

        <div class="schedule-item" *ngFor="let event of todaysEpisodes"
          (click)="openEpisodeDetails(event.tvProductionTrackerId)" style="cursor: pointer;">
          <div class="schedule-left">
            <!-- <span class="status-dot" [ngClass]="{
              'dot-high': event.priority === 'HIGH',
              'dot-medium': event.priority === 'MEDIUM',
              'dot-low': event.priority === 'LOW'
            }"></span> -->
            <div class="schedule-time">{{ event.shootTime || 'All Day' }}</div>
            <div class="schedule-name">{{ event.episodeName || 'Unnamed' }}</div>
          </div>
          <span class="schedule-badge" [ngClass]="getStageClass(event.episodeStatus).replace('stage-', 'badge-')">
            {{ statusMap[event.episodeStatus] || event.episodeStatus }}
          </span>
        </div>

        <div class="no-events" *ngIf="todaysEpisodes.length === 0"
          style="padding: 20px; text-align: center; color: var(--text-muted); font-size: 13px;">
          No events scheduled for today.
        </div>
      </div>

      <div class="panel-card">
        <div class="panel-title">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          Upcoming Deadlines
        </div>



        <div class="deadline-item deadline-blue">
          <div class="deadline-info">
            <span class="deadline-title">Editing Due</span>
            <span class="deadline-subtitle">{{ editingDueCount }} Episodes</span>
          </div>
          <span class="deadline-badge badge-due-today">Upcoming</span>
        </div>

        <div class="deadline-item deadline-purple">
          <div class="deadline-info">
            <span class="deadline-title">Graphics Due</span>
            <span class="deadline-subtitle">{{ graphicsDueCount }} Episodes</span>
          </div>
          <span class="deadline-badge badge-due-tomorrow">Upcoming</span>
        </div>

        <div class="deadline-item deadline-red">
          <div class="deadline-info">
            <span class="deadline-title">QC Pending</span>
            <span class="deadline-subtitle">{{ qcPendingCount }} Episodes</span>
          </div>
          <span class="deadline-badge badge-overdue">Upcoming</span>
        </div>

        <div class="deadline-item deadline-green">
          <div class="deadline-info">
            <span class="deadline-title">Publishing</span>
            <span class="deadline-subtitle">{{ publishingDueCount }} Episodes</span>
          </div>
          <span class="deadline-badge badge-today">Upcoming</span>
        </div>


      </div>


    </div>
  </div>
</div> <!-- End of !selectedEpisode -->

<div class="episode-details-page" id="detail-top" *ngIf="selectedEpisode">
  <!-- Detail View Header -->
  <div class="detail-top-header">
    <div class="detail-header-left">
      <div class="detail-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
          <line x1="7" y1="2" x2="7" y2="22"></line>
          <line x1="17" y1="2" x2="17" y2="22"></line>
          <line x1="2" y1="12" x2="22" y2="12"></line>
        </svg>
      </div>
      <div>
        <h1 class="detail-title">Episode Details</h1>
        <p class="detail-subtitle">TV Production Workflow</p>
      </div>
    </div>
    <div class="detail-header-right">
      <div class="detail-status-pill in-progress">
        <span class="status-dot"></span> IN PROGRESS
      </div>
      <button class="btn-close-detail" (click)="closeEpisodeDetails()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>

  <!-- Stepper -->
  <div class="detail-stepper">
    <div class="step completed">
      <div class="step-circle"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg></div>
      <div class="step-label">Episode Creation</div>
      <div class="step-sub">Completed</div>
    </div>
    <div class="step active">
      <div class="step-circle">2</div>
      <div class="step-label">Editor</div>
      <div class="step-sub">In Progress</div>
    </div>
    <div class="step">
      <div class="step-circle">3</div>
      <div class="step-label">Graphics</div>
      <div class="step-sub">Pending</div>
    </div>
    <div class="step">
      <div class="step-circle">4</div>
      <div class="step-label">Title</div>
      <div class="step-sub">Pending</div>
    </div>
    <div class="step">
      <div class="step-circle">5</div>
      <div class="step-label">Quality Check</div>
      <div class="step-sub">Pending</div>
    </div>
    <div class="step">
      <div class="step-circle">6</div>
      <div class="step-label">SEO</div>
      <div class="step-sub">Pending</div>
    </div>
    <div class="step">
      <div class="step-circle">7</div>
      <div class="step-label">Publishing</div>
      <div class="step-sub">Pending</div>
    </div>
    <div class="step">
      <div class="step-circle">8</div>
      <div class="step-label">Completed</div>
      <div class="step-sub">Pending</div>
    </div>
  </div>

  <!-- Episode Information -->
  <div class="detail-card full-width">
    <div class="card-header-flex">
      <div class="card-title-flex text-primary">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        Episode Information
      </div>
      <!-- <button class="btn-outline-primary">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
        Edit
      </button> -->
    </div>

    <div class="info-grid-5">
      <div class="info-item">
        <div class="info-label">ID</div>
        <div class="info-value">{{ selectedEpisode?.tvProductionTrackerId || '--' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">EPISODE NAME</div>
        <div class="info-value">{{ selectedEpisode?.episodeName || '--' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">EPISODE TYPE</div>
        <div class="info-value">{{ selectedEpisode?.episodeType || '--' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">ANCHOR</div>
        <div class="info-value">{{ selectedEpisode?.anchorUser || '--' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">DIRECTOR</div>
        <div class="info-value">{{ selectedEpisode?.director || '--' }}</div>
      </div>

      <div class="info-item">
        <div class="info-label">GUESTS</div>
        <div class="info-value">{{ selectedEpisode?.guest1 ? (selectedEpisode?.guest1 + (selectedEpisode?.guest2 ? ', '
          + selectedEpisode?.guest2 : '')) : '--' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">SHOOT DATE</div>
        <div class="info-value with-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          {{ selectedEpisode?.shootDate ? (selectedEpisode?.shootDate | date:'dd MMM yyyy') : '--' }}
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">SHOOT TIME</div>
        <div class="info-value with-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          10:30 AM - 12:30 PM
        </div>
      </div>
      <!-- <div class="info-item">
        <div class="info-label">PRIORITY</div>
        <div class="info-value"><span class="badge-priority medium">{{ selectedEpisode?.priority || '--' }}</span>
        </div>
      </div> -->

      <div class="info-item">
        <div class="info-label">DUE DATE</div>
        <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg> {{ (selectedEpisode?.episodeDueDate && selectedEpisode?.episodeDueDate !== 0 ?
          (selectedEpisode?.episodeDueDate | date:'dd MMM yyyy') : null) || '--' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">YOUTUBE URL</div>
        <div class="info-value youtube-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#FF0000"
            stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.94 2c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z">
            </path>
            <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="#FFFFFF"></polygon>
          </svg>
          <ng-container *ngIf="selectedEpisode?.episodeYouTubeURL; else noYoutube">
            <a [href]="selectedEpisode?.episodeYouTubeURL" target="_blank"
              style="color: inherit; text-decoration: none;">{{ selectedEpisode?.episodeYouTubeURL }}</a>
          </ng-container>
          <ng-template #noYoutube>--</ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="detail-grid-2">
    <!-- Editor Details -->
    <div class="detail-card">
      <div class="card-title-flex text-primary">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        Editor Details
      </div>
      <div class="info-grid-4">
        <div class="info-item">
          <div class="info-label">EDITOR USER</div>
          <div class="info-value">{{ selectedEpisode?.editorUser || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">ASSIGNED ON</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.assignToEditorOnDate && selectedEpisode?.assignToEditorOnDate !== 0 ?
            (selectedEpisode?.assignToEditorOnDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">START DATE</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.editStartDate && selectedEpisode?.editStartDate !== 0 ?
            (selectedEpisode?.editStartDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>

        <div class="info-item">
          <div class="info-label">DUE DATE</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.editDueDate && selectedEpisode?.editDueDate !== 0 ?
            (selectedEpisode?.editDueDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">END DATE</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.editEndDate && selectedEpisode?.editEndDate !== 0 ?
            (selectedEpisode?.editEndDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>

        <div class="info-item">
          <div class="info-label">DURATION</div>
          <div class="info-value">{{ selectedEpisode?.noOfDaysToEdit ? selectedEpisode?.noOfDaysToEdit + ' Days' : '--'
            }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">HOURS SPENT</div>
          <div class="info-value">{{ selectedEpisode?.noOfHoursToEdit ? selectedEpisode?.noOfHoursToEdit + ' Hours' :
            '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">STATUS</div>
          <div class="info-value"><span class="badge-status"
              [ngClass]="{'completed': selectedEpisode?.editEndDate, 'in-progress': selectedEpisode?.editStartDate && !selectedEpisode?.editEndDate, 'pending': !selectedEpisode?.editStartDate}">{{
              selectedEpisode?.editEndDate ? 'COMPLETED' : (selectedEpisode?.editStartDate ? 'IN PROGRESS' : 'PENDING')
              }}</span></div>
        </div>
      </div>

      <!--       <div class="notes-section">
        <div class="notes-header">Editor Notes (2)</div>
        <div class="notes-grid-2">
          <div class="note-card note-blue">
            <p>First cut completed. Working on color grading.</p>
            <div class="note-meta">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg> 23 May 2025, 5:40 PM</span>
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg> Manche Thirumalesh</span>
            </div>
          </div>
          <div class="note-card note-blue">
            <p>Initial footage review done. Rough cut in progress.</p>
            <div class="note-meta">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg> 23 May 2025, 5:31 PM</span>
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg> Manche Thirumalesh</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Title Details -->
    <div class="detail-card">
      <div class="card-title-flex text-orange">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        Title Details
      </div>
      <div class="info-grid-3">
        <div class="info-item">
          <div class="info-label">TITLE CREATION USER</div>
          <div class="info-value">{{ selectedEpisode?.titleCreationUser || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">ASSIGNED ON</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.assignToTitleTeamOnDate && selectedEpisode?.assignToTitleTeamOnDate !== 0 ?
            (selectedEpisode?.assignToTitleTeamOnDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>

        <div class="info-item">
          <div class="info-label">DUE DATE</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.titleDueDate && selectedEpisode?.titleDueDate !== 0 ?
            (selectedEpisode?.titleDueDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">APPROVED TITLE</div>
          <div class="info-value">{{ selectedEpisode?.approvedTitle || '--' }}</div>
        </div>
      </div>

      <div class="info-item mt-3">
        <div class="info-label">SUGGESTED TITLES ({{ selectedEpisode?.suggestedTitles?.length || 0 }})</div>
        <div class="tags-flex">
          <span class="tag tag-orange" *ngFor="let t of selectedEpisode?.suggestedTitles">{{ t.titleName || '--'
            }}</span>
        </div>
      </div>

      <!--       <div class="notes-section mt-4">
        <div class="notes-header">Title Notes (2)</div>
        <div class="notes-grid-2">
          <div class="note-card note-orange">
            <p>Waiting for final approval from producer.</p>
            <div class="note-meta">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg> 23 May 2025, 4:20 PM</span>
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg> Jane Cooper</span>
            </div>
          </div>
          <div class="note-card note-orange">
            <p>Suggested new titles for better SEO ranking.</p>
            <div class="note-meta">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg> 22 May 2025, 11:15 AM</span>
              <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg> Jane Cooper</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

  <div class="detail-grid-3">
    <!-- Graphics Details -->
    <div class="detail-card">
      <div class="card-title-flex text-purple">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
        </svg>
        Graphics Details
      </div>
      <div class="info-grid-2">
        <div class="info-item">
          <div class="info-label">GRAPHICS USER</div>
          <div class="info-value">{{ selectedEpisode?.graphicsUser || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">ASSIGNED ON</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.assignToGraphicsTeamOnDate && selectedEpisode?.assignToGraphicsTeamOnDate !== 0
            ? (selectedEpisode?.assignToGraphicsTeamOnDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>

        <div class="info-item">
          <div class="info-label">DUE DATE</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.graphicsDueDate && selectedEpisode?.graphicsDueDate !== 0 ?
            (selectedEpisode?.graphicsDueDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">COMPLETED ON</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.graphicsCreationEndDate && selectedEpisode?.graphicsCreationEndDate !== 0 ?
            (selectedEpisode?.graphicsCreationEndDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">DURATION</div>
          <div class="info-value">4 Days</div>
        </div>
        <div class="info-item">
          <div class="info-label">STATUS</div>
          <div class="info-value"><span class="badge-status"
              [ngClass]="{'completed': selectedEpisode?.graphicsCreationEndDate, 'in-progress': selectedEpisode?.graphicsCreationStartDate && !selectedEpisode?.graphicsCreationEndDate, 'pending': !selectedEpisode?.graphicsCreationStartDate}">{{
              selectedEpisode?.graphicsCreationEndDate ? 'COMPLETED' : (selectedEpisode?.graphicsCreationStartDate ? 'IN
              PROGRESS' : 'PENDING') }}</span></div>
        </div>
        <!-- <div class="info-item">
          <div class="info-label">PROGRESS</div>
          <div class="info-value fw-600">{{ selectedEpisode?.graphicsCreationEndDate ? '100%' : (selectedEpisode?.graphicsCreationStartDate ? '50%' : '0%') }}</div>
        </div> -->
      </div>

      <!--       <div class="notes-section mt-4">
        <div class="notes-header">Graphics Notes (1)</div>
        <div class="note-card note-purple">
          <p>Thumbnail design is in progress. Will share samples soon.</p>
          <div class="note-meta">
            <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg> 23 May 2025, 1:10 PM</span>
            <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg> Alex Johnson</span>
          </div>
        </div>
      </div> -->
    </div>

    <!-- SEO Details -->
    <div class="detail-card">
      <div class="card-title-flex text-teal">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        SEO Details
      </div>
      <div class="info-grid-2">
        <div class="info-item">
          <div class="info-label">SEO USER</div>
          <div class="info-value">{{ selectedEpisode?.seoUser || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">ASSIGNED ON</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.assignToSEOTeamOnDate && selectedEpisode?.assignToSEOTeamOnDate !== 0 ?
            (selectedEpisode?.assignToSEOTeamOnDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>

        <div class="info-item">
          <div class="info-label">DUE DATE</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.seoDueDate && selectedEpisode?.seoDueDate !== 0 ? (selectedEpisode?.seoDueDate |
            date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">COMPLETED ON</div>
          <div class="info-value">{{ (selectedEpisode?.seoTeamEndDate && selectedEpisode?.seoTeamEndDate !== 0 ?
            (selectedEpisode?.seoTeamEndDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">STATUS</div>
          <div class="info-value"><span class="badge-status"
              [ngClass]="{'completed': selectedEpisode?.seoTeamEndDate, 'in-progress': selectedEpisode?.seoTeamStartDate && !selectedEpisode?.seoTeamEndDate, 'pending': !selectedEpisode?.seoTeamStartDate}">{{
              selectedEpisode?.seoTeamEndDate ? 'COMPLETED' : (selectedEpisode?.seoTeamStartDate ? 'IN PROGRESS' :
              'PENDING') }}</span></div>
        </div>
        <!-- <div class="info-item">
          <div class="info-label">PROGRESS</div>
          <div class="info-value fw-600">{{ selectedEpisode?.seoTeamEndDate ? '100%' : (selectedEpisode?.seoTeamStartDate ? '50%' : '0%') }}</div>
        </div> -->
      </div>

      <!--       <div class="notes-section mt-4" style="margin-top: 3.5rem;">
        <div class="notes-header">SEO Notes (1)</div>
        <div class="note-card note-teal">
          <p>Meta description and tags research is in progress.</p>
          <div class="note-meta">
            <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg> 24 May 2025, 10:30 AM</span>
            <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg> David Lee</span>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Publishing Details -->
    <div class="detail-card">
      <div class="card-title-flex text-green">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 16 16 12 12 8"></polyline>
          <line x1="8" y1="12" x2="16" y2="12"></line>
        </svg>
        Publishing Details
      </div>
      <div class="info-grid-2">
        <div class="info-item">
          <div class="info-label">PUBLISHER</div>
          <div class="info-value">{{ selectedEpisode?.publishingUser || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">SCHEDULED ON</div>
          <div class="info-value">{{ (selectedEpisode?.assignToPublishingTeamOnDate &&
            selectedEpisode?.assignToPublishingTeamOnDate !== 0 ? (selectedEpisode?.assignToPublishingTeamOnDate |
            date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>

        <div class="info-item">
          <div class="info-label">DUE DATE</div>
          <div class="info-value with-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> {{ (selectedEpisode?.publishingDueDate && selectedEpisode?.publishingDueDate !== 0 ?
            (selectedEpisode?.publishingDueDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">PUBLISHED ON</div>
          <div class="info-value">{{ (selectedEpisode?.publishingEndDate && selectedEpisode?.publishingEndDate !== 0 ?
            (selectedEpisode?.publishingEndDate | date:'dd MMM yyyy') : null) || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">STATUS</div>
          <div class="info-value"><span class="badge-status"
              [ngClass]="{'completed': selectedEpisode?.publishingEndDate, 'in-progress': selectedEpisode?.publishingStartDate && !selectedEpisode?.publishingEndDate, 'pending': !selectedEpisode?.publishingStartDate}">{{
              selectedEpisode?.publishingEndDate ? 'COMPLETED' : (selectedEpisode?.publishingStartDate ? 'IN PROGRESS' :
              'PENDING') }}</span></div>
        </div>
        <!-- <div class="info-item">
          <div class="info-label">PROGRESS</div>
          <div class="info-value fw-600">{{ selectedEpisode?.publishingEndDate ? '100%' : (selectedEpisode?.publishingStartDate ? '50%' : '0%') }}</div>
        </div> -->
      </div>

      <!--       <div class="notes-section mt-4" style="margin-top: 3.5rem;">
        <div class="note-card note-green">
          <p><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              style="margin-bottom: -2px; margin-right:4px;">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg> Episode not yet scheduled for publishing.</p>
        </div>
      </div> -->
    </div>
  </div>

  <!-- Audit Timeline -->
  <div class="detail-card full-width">
    <div class="card-title-flex text-primary">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
      Audit Timeline
    </div>

    <div class="timeline-container">
      <div class="timeline-line"></div>

      <!-- Created -->
      <div class="timeline-item" *ngIf="selectedEpisode?.createdOn">
        <div class="timeline-icon bg-green-light text-green"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">{{ selectedEpisode?.createdOn | date:'dd MMM yyyy, hh:mm a' }}</div>
          <div class="tl-title">Episode Created</div>
          <div class="tl-user">{{ selectedEpisode?.createdBy || '--' }}</div>
        </div>
      </div>

      <!-- Assigned to Editor -->
      <div class="timeline-item" *ngIf="selectedEpisode?.assignToEditorOnDate">
        <div class="timeline-icon bg-blue-light text-primary"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">{{ selectedEpisode?.assignToEditorOnDate | date:'dd MMM yyyy, hh:mm a' }}</div>
          <div class="tl-title">Assigned to Editor</div>
          <div class="tl-user">{{ selectedEpisode?.editorUser || '--' }}</div>
        </div>
      </div>

      <!-- Assigned to Graphics -->
      <div class="timeline-item" *ngIf="selectedEpisode?.assignToGraphicsTeamOnDate">
        <div class="timeline-icon bg-purple-light text-purple"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">{{ selectedEpisode?.assignToGraphicsTeamOnDate | date:'dd MMM yyyy, hh:mm a' }}</div>
          <div class="tl-title">Assigned to Graphics Team</div>
          <div class="tl-user">{{ selectedEpisode?.graphicsUser || '--' }}</div>
        </div>
      </div>

      <!-- Assigned to Title Team -->
      <div class="timeline-item" *ngIf="selectedEpisode?.assignToTitleTeamOnDate">
        <div class="timeline-icon bg-orange-light text-orange"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="4 7 4 4 20 4 20 7"></polyline>
            <line x1="9" y1="20" x2="15" y2="20"></line>
            <line x1="12" y1="4" x2="12" y2="20"></line>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">{{ selectedEpisode?.assignToTitleTeamOnDate | date:'dd MMM yyyy, hh:mm a' }}</div>
          <div class="tl-title">Assigned to Title Team</div>
          <div class="tl-user">{{ selectedEpisode?.titleCreationUser || '--' }}</div>
        </div>
      </div>

      <!-- Assigned to SEO Team -->
      <div class="timeline-item" *ngIf="selectedEpisode?.assignToSEOTeamOnDate">
        <div class="timeline-icon bg-teal-light text-teal"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">{{ selectedEpisode?.assignToSEOTeamOnDate | date:'dd MMM yyyy, hh:mm a' }}</div>
          <div class="tl-title">Assigned to SEO Team</div>
          <div class="tl-user">{{ selectedEpisode?.seoUser || '--' }}</div>
        </div>
      </div>

      <!-- Assigned to QC Team -->
      <div class="timeline-item" *ngIf="selectedEpisode?.assignToQualityCheckTeamOnDate">
        <div class="timeline-icon bg-blue-light text-primary"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">{{ selectedEpisode?.assignToQualityCheckTeamOnDate | date:'dd MMM yyyy, hh:mm a' }}</div>
          <div class="tl-title">Assigned to QC Team</div>
          <div class="tl-user">{{ selectedEpisode?.qualityCheckUser || '--' }}</div>
        </div>
      </div>

      <!-- Assigned to Publishing Team -->
      <div class="timeline-item" *ngIf="selectedEpisode?.assignToPublishingTeamOnDate">
        <div class="timeline-icon bg-green-light text-green"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">{{ selectedEpisode?.assignToPublishingTeamOnDate | date:'dd MMM yyyy, hh:mm a' }}</div>
          <div class="tl-title">Assigned to Publishing Team</div>
          <div class="tl-user">{{ selectedEpisode?.publishingUser || '--' }}</div>
        </div>
      </div>

      <!-- Pending Placeholder (if no assignments) -->
      <div class="timeline-item pending"
        *ngIf="!selectedEpisode?.assignToEditorOnDate && !selectedEpisode?.assignToGraphicsTeamOnDate && !selectedEpisode?.assignToTitleTeamOnDate && !selectedEpisode?.assignToSEOTeamOnDate && !selectedEpisode?.assignToQualityCheckTeamOnDate && !selectedEpisode?.assignToPublishingTeamOnDate">
        <div class="timeline-icon bg-gray-light text-muted"><svg xmlns="http://www.w3.org/2000/svg" width="16"
            height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg></div>
        <div class="timeline-content">
          <div class="tl-date">-</div>
          <div class="tl-title text-muted">Awaiting Team Assignments</div>
          <div class="tl-user">-</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Common Notes (Chat View) -->
  <div class="detail-card full-width">
    <div class="card-title-flex text-primary">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
      Discussion / Chat
    </div>

    <div class="chat-container">
      <div class="chat-messages" *ngIf="selectedEpisode?.commonNotes?.length > 0; else noNotes">
        <div class="chat-message" *ngFor="let note of selectedEpisode.commonNotes">
          <div class="chat-avatar">
            {{ note.userName ? note.userName.charAt(0) : 'U' }}
          </div>
          <div class="chat-content">
            <div class="chat-header">
              <span class="chat-user">{{ note.userName || 'System/User' }}</span>
              <span class="chat-date">{{ note.date | date:'dd MMM yyyy, h:mm a' }}</span>
            </div>
            <div class="chat-bubble">
              {{ note.episodeNotes || note.commonNotes || note.editorNotes || note.titleNotes || note.graphicsNotes ||
              note.seoNotes || note.qualityCheckNotes || note.publishingNotes || 'No content' }}
            </div>
          </div>
        </div>
      </div>
      <ng-template #noNotes>
        <div class="no-chat-messages">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          <p>No discussion notes added yet.</p>
        </div>
      </ng-template>
    </div>
  </div>

</div>



<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center;">
        <h5 class="modal-title" id="exampleModalLabel" style="margin: 0;">Add Episode</h5>
        <!-- <span data-dismiss="modal" style="cursor: pointer;">
          <i class="bi bi-x-lg" (click)="closePopUp()" id="closeModalButton1"></i>
        </span> -->
      </div>
      <div class="modal-body">
        <div [formGroup]="episodeForm">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Episode Name <span class="required">*</span></label>
                <input formControlName="episodeName" type="text" class="form-control">

                <span class="err" *ngIf="episodeForm.get('episodeName').invalid && formSubmit">Episode
                  Name required</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Episode Type <span class="required">*</span></label>
                <select formControlName="episodeType" class="form-control">
                  <option value="">Select Episode Type</option>
                  <option *ngFor="let type of episodeTypes" [value]="type">{{type}}</option>
                </select>
                <span class="err" *ngIf="episodeForm.get('episodeType').invalid && formSubmit">Episode
                  Type required</span>
              </div>
            </div>
            <!-- <div class="col-md-12">
                            <div class="form-group">
                                <label>YouTube URL</label>
                                <input formControlName="episodeYouTubeURL" type="text" class="form-control">
                            </div>
                        </div> -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Anchor</label>
                <select formControlName="anchorUser" class="form-control">
                  <option value="">Select Anchor</option>
                  <option *ngFor="let user of anchorUserList" [value]="user.userName">
                    {{user.userName}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Director</label>
                <select formControlName="director" class="form-control">
                  <option value="">Select Director</option>
                  <option *ngFor="let user of directorUserList" [value]="user.userName">
                    {{user.userName}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Guest</label>
                <input formControlName="guest1" type="text" class="form-control">
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Shoot Date <span class="required">*</span></label>
                <input formControlName="shootDate" type="date" class="form-control">
                <span class="err" *ngIf="episodeForm.get('shootDate').invalid && formSubmit">Shoot Date
                  required</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Shoot Time</label>
                <input formControlName="shootTime" type="time" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="custom-modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closePopUp()" id="closeModalButton1"
            (clickOutside)="closePopUp()" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" (click)="addEpisode()">Add Episode</button>
        </div>
      </div>
    </div>
  </div>
</div>